import { render, staticRenderFns } from "./ChatBotAdmin.vue?vue&type=template&id=1fb07eb8&scoped=true"
import script from "./ChatBotAdmin.vue?vue&type=script&lang=js"
export * from "./ChatBotAdmin.vue?vue&type=script&lang=js"
import style0 from "./ChatBotAdmin.vue?vue&type=style&index=0&id=1fb07eb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb07eb8",
  null
  
)

export default component.exports